module.exports = __webpack_public_path__ + "img/tertiary_6x1_z16.06b78ce1.svg";